import { Node as ProsemirrorNode } from '@tiptap/pm/model';
import { KeywordVolumeData } from './types';

export enum keywordCategory {
  'high' = 'high',
  'medium' = 'medium',
  'low' = 'low',
}

interface Result {
  from: number;
  to: number;
  category?: keywordCategory;
}

// This is the base class for all plugins. It's not used directly, but it's extended by other plugins.
export default class UnderlinerPlugin {
  protected doc;
  protected data: KeywordVolumeData;
  private results: Array<Result> = [];

  constructor(doc: ProsemirrorNode, data: KeywordVolumeData) {
    this.doc = doc;
    this.data = data;
  }

  record(from: number, to: number, category?: keywordCategory) {
    this.results.push({
      from,
      to,
      category,
    });
  }

  scan() {
    return this;
  }

  getResults() {
    return this.results;
  }
}
